<template>
    <div class="booking__filter">
        <div class="columns is-multiline is-mobile">
            <div class="column is-6-mobile is-2-desktop">
                <label class="booking__filter__label">{{ $t('bookings.filter.isNew') }}:</label>
                <span class="select is-small">
                    <select name="is_new" v-model="isNew" v-on:change="newChanged($event)">
                        <option value="">{{ $t('bookings.filter.showAll') }}</option>
                        <option value="true">{{ $t('bookings.filter.isNew') }}</option>
                        <option value="false">{{ $t('bookings.filter.isOld') }}</option>
                    </select>
                </span>
            </div>
            <div class="column is-6-mobile is-2-desktop" v-if="!pmsApiActive">
                <label class="booking__filter__label">{{ $t('bookings.filter.isDone') }}:</label>
                <span class="select is-small">
                    <select name="is_processed" v-model="isProcessed" v-on:change="doneChanged($event)">
                        <option value="">{{ $t('bookings.filter.showAll') }}</option>
                        <option value="true">{{ $t('bookings.filter.isDone') }}</option>
                        <option value="false">{{ $t('bookings.filter.isNotDone') }}</option>
                    </select>
                </span>
            </div>
            <div class="column is-12-mobile is-5-desktop">
                <div class="is-clearfix">
                    <label class="booking__filter__label">{{ $t('bookings.filter.selectPeriod') }}:</label>
                    <div class="flatpickr-wrapper">
                        <datepicker class="time-period-input"
                                    :placeholder="$t('generic.calendar.placeholder')"
                                    :config="datepickerOptions"
                                    v-model="dateFrom"
                                    @click.native="openStartDate()">
                            <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                            <a class="button" data-clear @click="clearStartDate()"><i class="fa fa-close"></i></a>
                        </datepicker>
                    </div>
                    <span class="booking__filter__spacer">bis</span>
                    <div class="flatpickr-wrapper">
                        <datepicker class="time-period-input"
                                    :config="datepickerOptions"
                                    :placeholder="$t('generic.calendar.placeholder')"
                                    v-model="dateUntil"
                                    @click.native="openEndDate()">
                            <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                            <a class="button" data-clear @click="clearEndDate()"><i class="fa fa-close"></i></a>
                        </datepicker>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3-desktop">
                <label class="booking__filter__label">{{ $t('bookings.filter.search')}}:</label>
                <p class="control has-icon">
                    <input type="text" :placeholder="$t('bookings.filter.searchPlaceholder')" class="input is-small" v-model="q" @click="searchChanged()"> <i class="fa fa-search"></i>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vue-bulma-datepicker';
    import { AppModel } from '../../../models';
    import { Tracking } from '../../../utils';

    import {debounce} from 'lodash';

    export default {
        name: 'booking-filter',
        components: {
            Datepicker,
        },
        props: {
            value: {
                type: Object,
                'default': () => ({
                    date_from: '',
                    date_until: '',
                    q: '',
                    is_new: '',
                    is_processed: '',
                }),
            },
            pmsApiActive: {
                type: Boolean,
                default: false,
            },
        },

        created() {
            this.searchUpdated = debounce(this.searchUpdated.bind(this), 500);
        },

        data() {
            return {
                q: this.value.q,
                isNew: this.value.is_new,
                isProcessed: this.value.is_processed,
                dateFrom: this.value.date_from,
                dateUntil: this.value.date_until,
                datepickerOptions: AppModel.datepickerOptions,
            };
        },

        computed: {
            filterData() {
                return {
                    is_new: this.isNew,
                    is_processed: this.isProcessed,
                    date_from: this.dateFrom,
                    date_until: this.dateUntil,
                    q: this.q,
                };
            },
        },

        watch: {
            dateFrom(newVal, oldVal) {
                this.emitChange();
            },

            dateUntil(newVal, oldVal) {
                this.emitChange();
            },

            isNew(newVal, oldVal) {
                this.emitChange();
            },

            isProcessed(newVal, oldVal) {
                this.emitChange();
            },

            q(newVal, oldVal) {
                this.searchUpdated();
            },
        },

        methods: {
            emitChange() {
                this.$emit('input', this.filterData);
            },

            searchUpdated() {
                this.emitChange();
            },

            searchChanged() {
                Tracking.trackEvent('Bookings', 'filterChanged', 'search', null);
            },

            newChanged(event) {
                Tracking.trackEvent('Bookings', 'filterChanged', 'isNew', event.target.value);
            },

            doneChanged(event) {
                Tracking.trackEvent('Bookings', 'filterChanged', 'isDone', event.target.value);
            },

            openStartDate() {
                Tracking.trackEvent('Bookings', 'filterChanged', 'openStartDate', null);
            },

            openEndDate() {
                Tracking.trackEvent('Bookings', 'filterChanged', 'openEndDate', null);
            },

            clearStartDate() {
                this.dateFrom = null;
                Tracking.trackEvent('Bookings', 'filterChanged', 'clearStartDate', null);
            },

            clearEndDate() {
                this.dateUntil = null;
                Tracking.trackEvent('Bookings', 'filterChanged', 'clearEndDate', null);
            }
        }
    };
</script>

<style lang="scss">
    @import 'booking-filter.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/booking/bookingFilter.vue